import React from 'react';

function Loader(props) {
    return (
        <div className="loader"/>
    );
}

export default Loader;
